import builder from "@builder.io/react";
// the following line is needed to load the builder.io widgets (carousel, tabs, etc.)
// eslint-disable-next-line import/no-unassigned-import
import "@builder.io/widgets/dist/lib/builder-widgets-async";
import { registerBuilderComponents } from "@faire/web--source/builder/registerBuilderComponents/registerBuilderComponents";
import { registerBuilderDesignTokens } from "@faire/web--source/builder/registerBuilderDesignTokens/registerBuilderDesignTokens";
import once from "lodash/once";

export const initializeBuilder = once((apiKey: string | undefined) => {
  if (apiKey) {
    builder.init(apiKey);
    registerBuilderComponents();
    registerBuilderDesignTokens();
  }
});
